import React from 'react';
import { Check } from 'lucide-react';

interface OnboardingProgressProps {
  currentStage: number;
  totalStages: number;
  stages: string[];
  organization?: any;
}

export const OnboardingProgress: React.FC<OnboardingProgressProps> = ({
  currentStage,
  totalStages,
  stages,
}) => {
  return (
    <div className="w-full bg-white dark:bg-transparent border-b border-gray-300 dark:border-white/10 py-6 shadow-sm">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-wrap md:flex-nowrap items-center justify-center md:justify-between gap-4 md:gap-0">
          {stages.map((stage, index) => {
            const stageNumber = index + 1;
            const isCompleted = stageNumber < currentStage;
            const isCurrent = stageNumber === currentStage;

            return (
              <React.Fragment key={stageNumber}>
                <div className="flex flex-col items-center">
                  <div
                    className={`w-10 h-10 md:w-12 md:h-12 rounded-full flex items-center justify-center font-bold text-base md:text-lg transition-all ${
                      isCompleted
                        ? 'bg-gradient-to-br from-green-600 to-green-700 text-white shadow-md'
                        : isCurrent
                          ? 'bg-yellow-400 text-gray-900 shadow-lg ring-4 ring-yellow-200 dark:ring-yellow-700/50'
                          : 'bg-gray-100 dark:bg-white/10 text-gray-600 dark:text-gray-300 border-2 border-gray-200 dark:border-white/10'
                    }`}
                  >
                    {isCompleted ? <Check className="w-5 h-5 md:w-6 md:h-6" /> : stageNumber}
                  </div>
                  <span
                    className={`mt-1 md:mt-2 text-xs md:text-sm font-semibold ${
                      isCurrent
                        ? 'text-yellow-700 dark:text-yellow-400'
                        : isCompleted
                          ? 'text-green-700 dark:text-green-400'
                          : 'text-gray-500 dark:text-gray-400'
                    }`}
                  >
                    {stage}
                  </span>
                </div>
                {index < totalStages - 1 && (
                  <div className="hidden md:flex flex-1 h-1 mx-2 md:mx-4 mb-6 rounded-full overflow-hidden min-w-[40px]">
                    <div
                      className={`h-full w-full transition-all duration-500 ${
                        isCompleted ? 'bg-gradient-to-r from-green-500 to-green-600' : 'bg-gray-200 dark:bg-white/10'
                      }`}
                    ></div>
                  </div>
                )}
              </React.Fragment>
            );
          })}
        </div>
      </div>
    </div>
  );
};
